<template>
  <div v-if="showPrices" class="bomPriceTotal__wrapper">
    <div class="bomPriceTotal__price">
      Your Price: {{ formatedPrice }}
      <span class="bomPriceTotal__priceCurrency">{{
        displayCurrencyCode
      }}</span>
    </div>
    <div class="bomPriceTotal__msrp">
      MSRP: {{ formatedMsrp }}
      <span class="bomPriceTotal__msrpCurrency">{{ displayCurrencyCode }}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import UtilityService from "../../../services/UtilityService";

export default {
  data() {
    return {
      hideCurrencyCode: false
    };
  },
  computed: {
    ...mapGetters("enhancedproduct", ["showPrices"]),
    ...mapGetters("enhancedBom", [
      "getBillOfMaterials",
      "getCurrencySymbol",
      "getBomSourceOfTruth",
      "getCurrencyCode"
    ]),
    calculateTotalPrice() {
      const totalPrice = this.getBomSourceOfTruth
        .map(({ Price, DefaultQuantity }) => {
          // this handles the the case where there isThirdPartyProduct is true and price is null
          const price =
            null === Price && DefaultQuantity
              ? 0
              : Price.RawPrice * DefaultQuantity;
          return parseFloat(price);
        })
        .reduce((prev, curr) => curr + prev, 0);

      return this.zeroAndNegativePriceCheck(totalPrice, "Please Call");
    },
    calculateTotalMSRP() {
      const totalMsrp = this.getBomSourceOfTruth
        .map(({ Price, DefaultQuantity }) => {
          // this handles the the case where there isThirdPartyProduct is true and price is null
          const price =
            null === Price
              ? 0 && DefaultQuantity
              : Price.RawMSRP * DefaultQuantity;

          return parseFloat(price);
        })
        .reduce((prev, curr) => curr + prev, 0);

      return this.zeroAndNegativePriceCheck(totalMsrp, "Please Call");
    },
    formatedPrice() {
      const totalPrice = this.calculateTotalPrice;

      // calculated price is returning a message not a total
      if (isNaN(parseInt(totalPrice))) {
        return totalPrice;
      }
      return UtilityService.formattedCurrencyString(
        totalPrice,
        this.getCurrencySymbol
      );
    },
    formatedMsrp() {
      const totalMsrp = this.calculateTotalMSRP;

      // calculated price is returning a message not a total
      if (isNaN(parseInt(totalMsrp))) {
        return totalMsrp;
      }
      return UtilityService.formattedCurrencyString(
        this.calculateTotalMSRP,
        this.getCurrencySymbol
      );
    },

    displayCurrencyCode() {
      const { hideCurrencyCode, getCurrencyCode } = this;
      if (true === hideCurrencyCode) {
        return null;
      }
      return getCurrencyCode;
    }
  },
  methods: {
    // checks for price less than zero and shows a message
    zeroAndNegativePriceCheck(totalPrice, lessThanZeroMsg) {
      if (totalPrice > 0) {
        // we want to show currency code if price is greater than 0
        if (true === this.hideCurrencyCode) {
          this.hideCurrencyCode = false;
        }
        return totalPrice;
      } else {
        // we want to hide currency code if price is zero or less
        if (false === this.hideCurrencyCode) {
          this.hideCurrencyCode = true;
        }
        return lessThanZeroMsg;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.bomPriceTotal {
  &__wrapper {
    margin: 23px 0;
    border-bottom: 3px solid #e5e5e5;
    font-family: $font-family-sans-serif-regular;
  }
  &__price {
    color: rgb(51, 51, 51);
    font-size: 24px;
    text-align: left;
    letter-spacing: 0.25px;
    margin-bottom: 23px;
  }
  &__priceCurrency {
    color: rgb(51, 51, 51);
    font-size: 20px;
    letter-spacing: 0.25px;
  }
  &__msrp {
    color: rgb(102, 103, 102);
    font-size: 16px;
    letter-spacing: 0.25px;
    line-height: 24px;
    text-align: left;
    margin-bottom: 23px;
  }
  &__msrpCurrency {
    color: rgb(102, 103, 102);
    font-size: 12px;
    letter-spacing: 0.25px;
    line-height: 24px;
  }
}
</style>
